import { LocalDate } from '../../../../models';
export interface ShipmentDeliveryDatesModel {
  estimatedDeliveryDate: LocalDate | null;
  actualDeliveryDate: LocalDate | null;
}
